import React from 'react';
import { Grid } from '@mui/material';
import Ship from '../../Models/Interfaces/Ship';
import ShipDetails from './ShipDetails';

interface Props {
  companyShip: Ship | null;
  shipTo: Ship | null;
}

const ShipInfoGrid: React.FC<Props> = ({ companyShip, shipTo }) => (
  <Grid container spacing={3}>
    <Grid item xs={12} sm={6}>
      <ShipDetails title="Frá" ship={companyShip} />
    </Grid>
    <Grid item xs={12} sm={6}>
      <ShipDetails title="Til" ship={shipTo} />
    </Grid>
  </Grid>
);

export default ShipInfoGrid;
